// extracted by mini-css-extract-plugin
module.exports = {"list":"AuthorCitationListView__list","headerTitleReviewCount":"AuthorCitationListView__headerTitleReviewCount"};